import Component from './dashboardV2.component';
import { Config } from './dashboardV2.config';

export default { Component, config: Config };
